import * as React from 'react';
import { Input, Label } from '../modules';

interface IInputLabelProps {
  type: string;
  name: string;
  label: string;
  required?: boolean;
}

interface IInputLabelState {
  isEmpty: boolean;
}

class InputLabel extends React.Component<IInputLabelProps> {
  public state: IInputLabelState;

  constructor(props: IInputLabelProps) {
    super(props);
    this.state = {
      isEmpty: true
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(evt: any) {
    const value = evt.target.value;
    const empty = !(value.length > 0);

    this.setState({ isEmpty: empty });
  }

  render() {
    const { type, name, required, label } = this.props;
    const inputId = 'input-' + name;

    return (
      <div className="form__item">
        <Input id={inputId} type={type} required={required} onChange={this.handleChange} />
        {this.state.isEmpty &&
          <Label to={inputId} text={label} />
        }
      </div>
    );
  }
}

export default InputLabel;



// WEBPACK FOOTER //
// ./src/modules/Form/InputLabel.tsx